import { useQuery } from '@tanstack/react-query';

import { ApiClientError } from '@/lib/api-client';
import { fetchBlockers } from './api';
import type { BlockerDashboard } from './types';

/**
 * FR-016 cross-batch blocker dashboard for the caller's scope. Polled so newly
 * cleared/raised blockers surface without a reload; 403 is surfaced as
 * `isForbidden` so the page can show a missing-permission hint.
 */
export const useBlockers = () => {
  const query = useQuery<BlockerDashboard, ApiClientError>({
    queryKey: ['dashboard', 'blockers'],
    queryFn: fetchBlockers,
    refetchInterval: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiClientError && (error.status === 401 || error.status === 403)) {
        return false;
      }
      return failureCount < 2;
    },
  });

  const isForbidden = query.error instanceof ApiClientError && query.error.status === 403;
  return { ...query, isForbidden };
};
